import { forwardRef, Fragment, isValidElement, cloneElement, createElement, useRef, useCallback } from "react";
import { classNames as t } from "./class-names.js";
import { match as u } from "./match.js";
var M = ((a) => (a[a.None = 0] = "None", a[a.RenderStrategy = 1] = "RenderStrategy", a[a.Static = 2] = "Static", a))(M || {}), O = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(O || {});
function H({ ourProps: r, theirProps: n, slot: e, defaultTag: a, features: s, visible: t2 = true, name: l, mergeRefs: i }) {
  i = i != null ? i : A;
  let o = N(n, r);
  if (t2) return b(o, e, a, l, i);
  let y = s != null ? s : 0;
  if (y & 2) {
    let { static: f = false, ...u2 } = o;
    if (f) return b(u2, e, a, l, i);
  }
  if (y & 1) {
    let { unmount: f = true, ...u$1 } = o;
    return u(f ? 0 : 1, { [0]() {
      return null;
    }, [1]() {
      return b({ ...u$1, hidden: true, style: { display: "none" } }, e, a, l, i);
    } });
  }
  return b(o, e, a, l, i);
}
function b(r, n = {}, e, a, s) {
  let { as: t$1 = e, children: l, refName: i = "ref", ...o } = h(r, ["unmount", "static"]), y = r.ref !== void 0 ? { [i]: r.ref } : {}, f = typeof l == "function" ? l(n) : l;
  "className" in o && o.className && typeof o.className == "function" && (o.className = o.className(n)), o["aria-labelledby"] && o["aria-labelledby"] === o.id && (o["aria-labelledby"] = void 0);
  let u2 = {};
  if (n) {
    let d = false, p = [];
    for (let [c, T] of Object.entries(n)) typeof T == "boolean" && (d = true), T === true && p.push(c.replace(/([A-Z])/g, (g) => `-${g.toLowerCase()}`));
    if (d) {
      u2["data-headlessui-state"] = p.join(" ");
      for (let c of p) u2[`data-${c}`] = "";
    }
  }
  if (t$1 === Fragment && (Object.keys(m(o)).length > 0 || Object.keys(m(u2)).length > 0)) if (!isValidElement(f) || Array.isArray(f) && f.length > 1) {
    if (Object.keys(m(o)).length > 0) throw new Error(['Passing props on "Fragment"!', "", `The current component <${a} /> is rendering a "Fragment".`, "However we need to passthrough the following props:", Object.keys(m(o)).concat(Object.keys(m(u2))).map((d) => `  - ${d}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map((d) => `  - ${d}`).join(`
`)].join(`
`));
  } else {
    let d = f.props, p = d == null ? void 0 : d.className, c = typeof p == "function" ? (...F) => t(p(...F), o.className) : t(p, o.className), T = c ? { className: c } : {}, g = N(f.props, m(h(o, ["ref"])));
    for (let F in u2) F in g && delete u2[F];
    return cloneElement(f, Object.assign({}, g, u2, y, { ref: s(f.ref, y.ref) }, T));
  }
  return createElement(t$1, Object.assign({}, h(o, ["ref"]), t$1 !== Fragment && y, t$1 !== Fragment && u2), f);
}
function I() {
  let r = useRef([]), n = useCallback((e) => {
    for (let a of r.current) a != null && (typeof a == "function" ? a(e) : a.current = e);
  }, []);
  return (...e) => {
    if (!e.every((a) => a == null)) return r.current = e, n;
  };
}
function A(...r) {
  return r.every((n) => n == null) ? void 0 : (n) => {
    for (let e of r) e != null && (typeof e == "function" ? e(n) : e.current = n);
  };
}
function N(...r) {
  if (r.length === 0) return {};
  if (r.length === 1) return r[0];
  let n = {}, e = {};
  for (let s of r) for (let t2 in s) t2.startsWith("on") && typeof s[t2] == "function" ? (e[t2] != null || (e[t2] = []), e[t2].push(s[t2])) : n[t2] = s[t2];
  if (n.disabled || n["aria-disabled"]) for (let s in e) /^(on(?:Click|Pointer|Mouse|Key)(?:Down|Up|Press)?)$/.test(s) && (e[s] = [(t2) => {
    var l;
    return (l = t2 == null ? void 0 : t2.preventDefault) == null ? void 0 : l.call(t2);
  }]);
  for (let s in e) Object.assign(n, { [s](t2, ...l) {
    let i = e[s];
    for (let o of i) {
      if ((t2 instanceof Event || (t2 == null ? void 0 : t2.nativeEvent) instanceof Event) && t2.defaultPrevented) return;
      o(t2, ...l);
    }
  } });
  return n;
}
function D(...r) {
  if (r.length === 0) return {};
  if (r.length === 1) return r[0];
  let n = {}, e = {};
  for (let s of r) for (let t2 in s) t2.startsWith("on") && typeof s[t2] == "function" ? (e[t2] != null || (e[t2] = []), e[t2].push(s[t2])) : n[t2] = s[t2];
  for (let s in e) Object.assign(n, { [s](...t2) {
    let l = e[s];
    for (let i of l) i == null || i(...t2);
  } });
  return n;
}
function W(r) {
  var n;
  return Object.assign(forwardRef(r), { displayName: (n = r.displayName) != null ? n : r.name });
}
function m(r) {
  let n = Object.assign({}, r);
  for (let e in n) n[e] === void 0 && delete n[e];
  return n;
}
function h(r, n = []) {
  let e = Object.assign({}, r);
  for (let a of n) a in e && delete e[a];
  return e;
}
export {
  M as RenderFeatures,
  O as RenderStrategy,
  m as compact,
  W as forwardRefWithAs,
  D as mergeProps,
  H as render,
  I as useMergeRefsFn
};
